/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ProxyBrowserPortRequestRequest = {
  sessionId: string;
  port: number;
  subpath: string;
  sessionToken?: string | null | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

/** @internal */
export const ProxyBrowserPortRequestRequest$inboundSchema: z.ZodType<
  ProxyBrowserPortRequestRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  session_id: z.string(),
  port: z.number().int(),
  subpath: z.string(),
  session_token: z.nullable(z.string()).optional(),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "session_id": "sessionId",
    "session_token": "sessionToken",
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ProxyBrowserPortRequestRequest$Outbound = {
  session_id: string;
  port: number;
  subpath: string;
  session_token?: string | null | undefined;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ProxyBrowserPortRequestRequest$outboundSchema: z.ZodType<
  ProxyBrowserPortRequestRequest$Outbound,
  z.ZodTypeDef,
  ProxyBrowserPortRequestRequest
> = z.object({
  sessionId: z.string(),
  port: z.number().int(),
  subpath: z.string(),
  sessionToken: z.nullable(z.string()).optional(),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    sessionId: "session_id",
    sessionToken: "session_token",
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function proxyBrowserPortRequestRequestToJSON(
  proxyBrowserPortRequestRequest: ProxyBrowserPortRequestRequest,
): string {
  return JSON.stringify(
    ProxyBrowserPortRequestRequest$outboundSchema.parse(
      proxyBrowserPortRequestRequest,
    ),
  );
}
export function proxyBrowserPortRequestRequestFromJSON(
  jsonString: string,
): SafeParseResult<ProxyBrowserPortRequestRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ProxyBrowserPortRequestRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ProxyBrowserPortRequestRequest' from JSON`,
  );
}
